export { default as BlogStyle } from './Blog.module.scss';
